// extracted by mini-css-extract-plugin
export default {"sampleContainer":"styles_sampleContainer__-W6p+","header":"styles_header__Gx+dI","container":"styles_container__tIyKH","overviewHeader":"styles_overviewHeader__Tu1aU"};